import type { ReactNode } from "react";
import { cn } from "../utils/cx.js";

export type TagColor = "default" | "primary" | "success" | "warning" | "error";

/**
 * Soft tinted status pill. Geometry + per-color tokens live in
 * `styles/components.css` (`.az-tag`) / `tokens.css` — kept custom so the fill
 * stays light rather than the heavier algorithm-derived colored chips.
 */
export function Tag({
  color = "default",
  className,
  children,
}: {
  color?: TagColor;
  className?: string;
  children: ReactNode;
}) {
  return <span className={cn(`az-tag az-tag--${color}`, className)}>{children}</span>;
}

/** Small numeric count badge (replaces antd Badge). */
export function Badge({ count, className }: { count: number; className?: string }) {
  if (count <= 0) return null;
  return (
    <span
      className={cn(
        "inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-destructive px-1.5 text-xs font-medium leading-none text-white",
        className,
      )}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
}
